<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="changeAddMenuDialog({ id: 0 })">
        新增权限菜单
      </el-button>
    </div>
    <el-table
      :data="routes"
      style="width: 100%; margin-bottom: 20px"
      row-key="id"
      border
      default-expand-all
      :tree-props="{ children: 'childers' }"
    >
      <!-- <el-table-column prop="date" label="日期" sortable width="180">
      </el-table-column> -->
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="url" label="url地址"> </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row }">
          <el-button type="primary" @click="changeAddMenuDialog(row)">
            新增
          </el-button>
          <el-button plain @click="editMenuAuth(row)"> 修改 </el-button>
          <el-button type="danger" @click="deleteMenuAuth(row)"> 删除 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="menuTitle" :visible.sync="addMenuDialog" width="30%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="菜单名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="url路径">
          <el-input v-model="form.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="code">
          <el-input v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMenuDialog = false">取 消</el-button>
        <el-button type="primary" @click="addMenu">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let time = null
import { httpAction } from "@/api/manage";
export default {
  data() {
    return {
      url: {
        addAuth: "/menuAuth/addAuth",
        getRoleList: "/menuAuth/getRoleList",
        updateAuth: '/menuAuth/updateAuth',
        deleteAuth: '/menuAuth/deleteAuth '
      },
      routes: [],
      addMenuDialog: false,
      form: {
        isValid: 0,
        resourceType: 2,
        name: "",
        url: "",
        parentid: "",
        code: "",
        id: null
      },
      menuTitle: '',
    };
  },
  methods: {
     addMenu() {
      let { url, name , code } = this.form;
      if (!url) {
        this.$message.warning("请输入url路径");
        return;
      }
      if (!name) {
        this.$message.warning("请输入菜单名称");
        return;
      }
      if (!code) {
        this.$message.warning("请输入code");
        return;
      }
      if (time !== null) {
        clearTimeout(time)
      }
      time = setTimeout(async () => {
        if (this.menuTitle === '新增菜单') {
          let res = await httpAction(this.url.addAuth, this.form, "post");
          if (res.code === 200) {
            this.$message.success("新增成功");
            this.getUserRoutes();
            this.addMenuDialog = false;
          } else {
            this.$message.error(res.msg);
          }
        } else {
          let res = await httpAction(this.url.updateAuth, this.form, "post");
          if (res.code === 200) {
            this.$message.success("修改成功");
            this.getUserRoutes();
            this.addMenuDialog = false;
          } else {
            this.$message.error(res.msg);
          }
        }
      },1000)
    },
    changeAddMenuDialog(row) {
      this.menuTitle = '新增菜单'
      this.form.parentid = row.id;
      this.form.url = "";
      this.form.name = "";
      this.form.code = "";
      this.form.id = null;
      this.addMenuDialog = true;
    },
    editMenuAuth (row) {
      this.menuTitle = '修改菜单'
      this.form.parentid = row.parentid;
      this.form.url = row.url;
      this.form.name = row.name;
      this.form.code = row.code;
      this.form.id = row.id;
      this.addMenuDialog = true;
    },
    async getUserRoutes() {
      let res = await httpAction(this.url.getRoleList, {}, "post");
      if (res.code === 200) {
        this.routes = res.data;
      }
    },
    async deleteMenuAuth (row) {
      // console.log(row);
      let res = await httpAction(this.url.deleteAuth, {id: row.id}, "post");
      if (res.code === 200) {
        this.$message.success("删除成功");
        this.getUserRoutes();
      } else {
        this.$message.warning("删除失败,请重新尝试");
      }
    }
  },
  mounted() {
    this.getUserRoutes();
  },
};
</script>

<style scoped lang="less">
.container {
  padding: 20px;
}
</style>
